module.exports = __webpack_public_path__ + "media/images/icon/ranking/second-559c41fad3aaaff7657546adb8121093.png";